import { useGetAgroOverviewKpisQuery } from 'services/api/Meteorology/Agro/Overview';
import useOverviewErrorState from './useOverviewErrorState';

export default function useOverviewKpis() {
  const {
    data, error, isFetching, refetch,
  } = useGetAgroOverviewKpisQuery();
  const errorKind = useOverviewErrorState(error, isFetching);

  return {
    summary: data, isFetching, errorKind, retry: refetch,
  };
}
